export const TRANSITION = "TRANSITION";
export const INVOICE = "INVOICE";
export const FOLDER = "FOLDER";
export const PRODUCTS = "PRODUCTS";
export const OTHER_PRODUCT = "OTHER_PRODUCT";
export const PRODUCT_DETAILS = "PRODUCT_DETAILS";
export const INTERVENTION = "INTERVENTION";
export const BREAKDOWN = "BREAKDOWN";

export const REFERENCE_STEPS = [
  TRANSITION,
  INVOICE,
  FOLDER,
  PRODUCTS,
  OTHER_PRODUCT,
  PRODUCT_DETAILS,
  INTERVENTION,
  BREAKDOWN,
];

export const STEPPER_ITEMS = [
  { id: 1, text: "Référence", i18n: "REFERENCE" },
  { id: 2, text: "Produit", i18n: "PRODUCT" },
  { id: 3, text: "Intervention", i18n: "INTERVENTION" },
  /* { id: 4, text: "Test", i18n: "STEPS.REFERENCE" }, */
  { id: 5, text: "Panne", i18n: "FAULT" },
];
